const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3VariablePlus {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'variablePlus', name: '📊 変数+', color1: '#FF9800', color2: '#F57C00',
            blocks: [
                { opcode: 'setVar', blockType: BlockType.COMMAND, text: '変数 [N] を [V] にする', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'var1' }, V: { type: ArgumentType.STRING, defaultValue: '0' } } },
                { opcode: 'getVar', blockType: BlockType.REPORTER, text: '変数 [N] の値', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'var1' } } },
                { opcode: 'changeVar', blockType: BlockType.COMMAND, text: '変数 [N] を [V] ずつ変える', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'var1' }, V: { type: ArgumentType.NUMBER, defaultValue: 1 } } },
                { opcode: 'varExists', blockType: BlockType.BOOLEAN, text: '変数 [N] は存在する？', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'var1' } } },
                { opcode: 'allVars', blockType: BlockType.REPORTER, text: 'すべての変数名' }
            ]
        };
    }
    _getVar(name) { var t = this.runtime.getEditingTarget(); if (!t) return null; return t.lookupVariableByNameAndType(name, ''); }
    setVar(args) { var v = this._getVar(args.N); if (v) v.value = Cast.toString(args.V); }
    getVar(args) { var v = this._getVar(args.N); return v ? v.value : ''; }
    changeVar(args) { var v = this._getVar(args.N); if (v) v.value = Number(v.value) + Cast.toNumber(args.V); }
    varExists(args) { return this._getVar(args.N) !== null; }
    allVars() { var t = this.runtime.getEditingTarget(); if (!t) return ''; return Object.values(t.variables).filter(function(v) { return v.type === ''; }).map(function(v) { return v.name; }).join(','); }
}
module.exports = Scratch3VariablePlus;